import React, { useState, useEffect } from 'react';
const LoadingWrapper = ({ children }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading ? (
        <div className="spinner-overlay">
          <div className="spinner-container"></div>
        </div>
      ) : (
        <div className="App">
          {children}
        </div>
      )}
    </>
  );
};

export default LoadingWrapper;
